import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import Modal from '../../../../../ui-kitchen/src/components/Modal';
import { getTranslation } from '../../../../../ui-kitchen/src/providers/TranslationProvider';
import { closeTockExperienceModal, goBackToOptions } from '../../../../../ui-kitchen/src/reducers/tockExperienceSlice';
import TockExperienceOffering from './TockExperienceOffering';

const TockExperienceOfferingModal = ({
  experience,
  isMobile,
  isOpen,
  closeOffering,
  venueName,
  selectedSeats,
  selectedDate,
  venueId,
  handleGoBackToOptions,
  hasBackButton,
}) => {
  const onRequestClose = () => {
    closeOffering();
  };

  return (
    <Modal
      isOpen={isOpen}
      onRequestClose={onRequestClose}
      shouldCloseOnEsc
      shouldCloseOnOverlayClick
      className="TockExperienceOfferingModal"
      contentLabel={getTranslation({
        translationKey: 'offering_modal_content_label',
        translationValues: {
          experienceName: experience?.name || getTranslation({
            translationKey: 'offering_modal_default_experience_name',
            fallback: 'Experience',
          }),
        },
        fallback: `Offering details: ${experience?.name || 'Experience'}`,
      })}
      styles={{
        content: {
          border: '1px solid #cacaca',
          borderRadius: '12px',
          inset: '30px 0 auto',
          maxHeight: '90vh',
          position: 'absolute',
          maxWidth: '760px',
          overflow: 'auto',
          padding: 0,
        },
      }}
    >
      <TockExperienceOffering
        experience={experience}
        isMobile={isMobile}
        onRequestClose={onRequestClose}
        selectedSeats={selectedSeats}
        selectedDate={selectedDate}
        venueId={venueId}
        venueName={venueName}
        handleGoBackToOptions={handleGoBackToOptions}
        hasBackButton={hasBackButton}
      />
    </Modal>
  );
};

TockExperienceOfferingModal.propTypes = {
  experience: PropTypes.shape({
    description: PropTypes.string,
    event_time_display: PropTypes.string,
    experience_type_display: PropTypes.string,
    id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    images: PropTypes.arrayOf(
      PropTypes.oneOfType([
        PropTypes.string,
        PropTypes.shape({
          id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
          image: PropTypes.string,
          src: PropTypes.string,
          url: PropTypes.string,
        }),
      ])
    ),
    name: PropTypes.string,
    price_type_display: PropTypes.string,
    slots: PropTypes.arrayOf(PropTypes.object),
    tock_notify_url: PropTypes.string,
  }),
  isMobile: PropTypes.bool,
  isOpen: PropTypes.bool,
  closeOffering: PropTypes.func.isRequired,
  venueName: PropTypes.string,
  selectedSeats: PropTypes.number,
  selectedDate: PropTypes.string,
  venueId: PropTypes.number,
  handleGoBackToOptions: PropTypes.func.isRequired,
  hasBackButton: PropTypes.bool,
};

TockExperienceOfferingModal.defaultProps = {
  experience: null,
  isMobile: false,
  isOpen: false,
  venueName: null,
  selectedSeats: null,
  selectedDate: null,
  venueId: null,
  hasBackButton: false,
};

const mapStateToProps = (state) => {
  const slice = state.tockExperience;
  return {
    isOpen: !!(slice && slice.isOfferingOpen),
    experience: (slice && slice.selectedExperience) || null,
    hasBackButton: (slice && slice.hasBackButton) || false,
    isMobile: !!(slice && slice.isMobile),
    venueName: (slice && slice.venueName) || null,
    selectedSeats: (slice && slice.selectedSeats) || null,
    selectedDate: (slice && slice.selectedDate) || null,
    venueId: (slice && slice.venueId) || null,
  };
};

const mapDispatchToProps = (dispatch) => ({
  closeOffering: () => dispatch(closeTockExperienceModal()),
  handleGoBackToOptions: () => dispatch(goBackToOptions()),
});

TockExperienceOfferingModal.displayName = 'TockExperienceOfferingModal';

export { TockExperienceOfferingModal };
export default connect(mapStateToProps, mapDispatchToProps)(TockExperienceOfferingModal);
